export interface Action {
    type: string;
    state: any;
  }
  export const SET_IS_SHOW_NEXT = "SET_IS_SHOW_NEXT";
  
  export const setIsShowNextBtn = (data: boolean): Action => ({
    type: SET_IS_SHOW_NEXT,
    state: data,
  });